import { Record } from 'immutable';
import { schema } from 'normalizr';

export const RelayControllerStatusHistory = new Record({
  id: undefined,
  relay_controller: undefined,
  iccid: undefined,
  ip_address: undefined,
  receive_time: undefined,
  status_type: undefined,
  version: undefined,
  board_type: undefined,
  current_time: undefined,
  unit_month: undefined,
  unit_day: undefined,
  unit_year: undefined,
  relay_max_currents_arbitrary_units: undefined,
  relay_max_currents_amps: undefined,
  relay_max_power_watts: undefined,
  relay_instantaneous_currents_arbitrary_units: undefined,
  relay_instantaneous_currents_amps: undefined,
  relay_instantaneous_power_watts: undefined,
  relay_thresholds: undefined,
  tamper_voltage: undefined,
  current_bias: undefined,
  schedule_lockout: undefined,
  threshold_check_minutes: undefined,
  threshold_percentage: undefined,
  power_loss_timeout: undefined,
  power_restore_timeout: undefined,
  positive_consumed_energy: undefined,
  negative_consumed_energy: undefined,
  checksum: undefined,
  com_checksum: undefined,
  checksum_1: undefined,
  sensors_checksum: undefined,
  switches_checksum: undefined,
  real_time_clock_checksum: undefined,
  relay_checksum: undefined,
  upgrade_checksum: undefined,
  max_data_session_minutes: undefined,
  check_in_minutes_after_midnight: undefined,
  received_signal_strength: undefined,
  uptime: undefined,
  radio_temperature: undefined,
  cpu_temperature: undefined,
  temperature: undefined,
  alarm_delay: undefined,
  delay_time: undefined,
  filter_rate: undefined,
  positive_threshold: undefined,
  on_delay: undefined,
  sample_time: undefined,
  radio_arn_version: undefined,
  relay_1_schedule_1: undefined,
  relay_1_schedule_2: undefined,
  relay_1_schedule_3: undefined,
  relay_1_schedule_4: undefined,
  relay_2_schedule_1: undefined,
  relay_2_schedule_2: undefined,
  relay_2_schedule_3: undefined,
  relay_2_schedule_4: undefined,
  relay_3_schedule_1: undefined,
  relay_3_schedule_2: undefined,
  relay_3_schedule_3: undefined,
  relay_3_schedule_4: undefined,
  relay_4_schedule_1: undefined,
  relay_4_schedule_2: undefined,
  relay_4_schedule_3: undefined,
  relay_4_schedule_4: undefined,
  generated_energy: undefined,
  device_alarms_enabled: undefined,
  features: [],
  automatic_alarm_cancel_time_minutes: null,
  automatic_rearm_time_minutes: null,
  delay_before_relays_power_off_seconds: null,
  relays_to_power_off: null,
  battery_voltage: null,
  cpu_input_voltage: null,
  thermistor_temperature: null,
  sunrise_sent_to_unit: null,
  sunset_sent_to_unit: null,
  relay_monitoring_enabled: null,
  relay_power_states: null,
  day_of_the_week_display: null,
  alternate_status: null,
  status: null,
  unit_dow: undefined,
  unit_time: undefined,
  alarm_states: undefined,
  major_version: undefined,
  minor_version: undefined,
  patch_version: undefined,
  relay_monitor: undefined,
  relay_reports: undefined,
  sensor_reports: undefined,
  network_parameters: undefined,
  vantage_parameters: undefined,
  last_receive_time: undefined,
  input_voltage_1: null,
  input_voltage_2: null,
  low_voltage_thresholds_v1: null,
  high_voltage_thresholds_v1: null,
  low_voltage_thresholds_v2: null,
  high_voltage_thresholds_v2: null,
  relay_1_action_v1_low: null,
  relay_1_action_v1_high: null,
  relay_2_action_v1_low: null,
  relay_2_action_v1_high: null,
  relay_1_action_v2_low: null,
  relay_1_action_v2_high: null,
  relay_2_action_v2_low: null,
  relay_2_action_v2_high: null,
  sensor_1_humidity: null,
  sensor_1_port: null,
  sensor_1_port_type: null,
  sensor_1_temp: null,
  sensor_2_humidity: null,
  sensor_2_port: null,
  sensor_2_port_type: null,
  sensor_2_temp: null,
  humidity_sensor_parameters: null,
  temperature_sensor_parameters: null,
});

export const relayControllerStatusHistorySchema = new schema.Entity('relayControllerStatusHistories');

// for reading in nested models, object with { field: schema }
// relayControllerStatusHistorySchema.define({  });
